document.addEventListener("DOMContentLoaded", function () {
    const questions = document.querySelectorAll(".gapp_faq-question");
  
    if (!questions.length) return;

      //Open first FAQ item on load...
      if(window.innerWidth <= 767) {
        const firstQuestion = questions[0];
        const firstAnswer = firstQuestion.nextElementSibling;
        const firstParent = firstQuestion.parentElement;
  
        firstParent.classList.add("active");
        firstAnswer.style.maxHeight = firstAnswer.scrollHeight + "px";
        firstQuestion.querySelector("img").setAttribute("src", firstQuestion.dataset.minusimg);
      }
  
    questions.forEach((question) => {
      question.addEventListener("click", () => {
        const answer = question.nextElementSibling;
        const parentItem = question.parentElement;
  
        // Close all other answers & remove active...
        document.querySelectorAll(".gapp_faq-item").forEach((item) => {
          const ans = item.querySelector(".gapp_faq-answer");
          const img = item.querySelector(".gapp_faq-question img");
          if (item !== parentItem) {
            item.classList.remove("active");
            ans.style.maxHeight = 0;
            img.setAttribute("src", item.querySelector(".gapp_faq-question").dataset.plusimg);
          }
        });
  
        // Toggle current answer & active...
        const isOpen = parentItem.classList.contains("active");
        if (isOpen) {
          answer.style.maxHeight = 0;
          parentItem.classList.remove("active");
          question.querySelector("img").setAttribute("src", question.dataset.plusimg);
        } else {
          answer.style.maxHeight = answer.scrollHeight + 'px';
          parentItem.classList.add("active");
          question.querySelector("img").setAttribute("src", question.dataset.minusimg);
        }
      });
    });
  });
  